import "./FilterBars.scss";
import React, { useContext } from "react";
import Button from "core/buttons/button/Button";
import ClearFiltersButton from "core/buttons/clear-filters-button/ClearFiltersButton";
import { FormattedMessage } from "react-intl";
import { Typography } from "core/typography/Typography";
import InfoContext from "pages/InfoContext";
import PopupLogo from "assets/icons/popup.svg";
import PropTypes from "prop-types";
import DateField from "./fields/DateField";
import BranchTagField from "./fields/BranchTagField";

const GlobalFilterBar = ({
  onSubmit,
  setPopupOpened,
  popupOpened,
  formatDate,
}) => {
  const {
    dateFilter,
    clientsFilter,
    signedByFilter,
    chargedByFilter,
    storedSignedBy,
    storedMissionType,
    setStoredSignedBy,
    setStoredClients,
    setStoredChargedBy,
    setStoredMissionType,
    setValue,
    errors,
  } = useContext(InfoContext);

  const hasActiveFilters = () => {
    return (
      clientsFilter?.length > 0 ||
      signedByFilter?.length > 0 ||
      chargedByFilter?.length > 0 ||
      storedMissionType?.length > 0
    );
  };

  const clearAllFilters = () => {
    setValue("clients_filter", []);
    setValue("signed_by_filter", []);
    setValue("charged_by_filter", []);
    setValue("mission_type_filter", []);
    setStoredClients([]);
    setStoredSignedBy([]);
    setStoredChargedBy([]);
    setStoredMissionType([]);
  };

  return (
    <div className="dashboard-filters-wrapper">
      <div className="dashboard-filters-title">
        <Typography
          className="title-3 violet text-uppercase"
          type="h2"
          label={
            <FormattedMessage
              id="stats_charts"
              defaultMessage="Statistiques à la date du 01/01/2021"
            />
          }
        />
        {dateFilter && dateFilter !== "" && (
          <Typography
            className="title-3 violet text-uppercase"
            type="h2"
            label={formatDate(dateFilter)}
            style={{ marginLeft: ".25rem" }}
          />
        )}
        <div className="label sourcesanspro-normal-shadow-blue-14px error">
          <button
            className="popup-information"
            onClick={() => setPopupOpened(!popupOpened)}
            alt="logo"
          >
            <img src={PopupLogo} alt="popup-infos" />
          </button>
        </div>
      </div>
      <form onSubmit={onSubmit}>
        <div className="section-1">
          <div className="main-block single-row">
            <div className="line-1">
              <div
                className={`cell-padding ${errors["date_filter"] && "errorCellColor"}`}
              >
                <DateField />
              </div>
              <div className="cell-padding">
                <BranchTagField
                  name="signed_by_filter"
                  label={{
                    id: "signed_by_filter",
                    defaultMessage: "Affaires signées par",
                  }}
                  selected={signedByFilter}
                  stored={storedSignedBy}
                  setStored={setStoredSignedBy}
                  id="signed-by-filter"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="buttons-container">
          <Button color="btn-medium gray-700" type="submit" id="dashboard_btn">
            <FormattedMessage id="dashboard_btn" defaultMessage="Rechercher" />
          </Button>
          <ClearFiltersButton
            onClear={clearAllFilters}
            hasActiveFilters={hasActiveFilters}
          />
        </div>
      </form>
    </div>
  );
};

GlobalFilterBar.propTypes = {
  onSubmit: PropTypes.func,
  setPopupOpened: PropTypes.func,
  popupOpened: PropTypes.bool,
  formatDate: PropTypes.func,
};

export default GlobalFilterBar;
